<script>

  import Multiselect from 'vue-multiselect'
export default {
  props: ["collection", "label", "name", 'value', 'name_col', 'bundles'],
  name: "oj-multiselect",
  components: { Multiselect },
  data() {
    return {
      value1: [],
    }
  },
  mounted() {

    this.value1 = []


    if (this.value ) {
      this.collection.forEach((c) => {
        if (this.value.indexOf(c.id) !== -1) {
          this.value1.push({id: c.id, name: c[this.name_col || 'name'], m: this.months_by_bundle(c.id)})
        }

      })
    }


    if (this.name_col!='name' && this.name_col){
      this.collection.forEach((c) => {
          c.name = c[this.name_col]
      })
    }

  },
  methods:{
    months_by_bundle(product_id){
      if (this.bundles){
        for (let i = 0; i < this.bundles.length; i++){
          let b = this.bundles[i]
          if (b.product_id==product_id){
            return b.months
          }

        }
      }
      return 0
    }
  },
  computed: {
    souhrn(){
      let s = {}
      this.value1.forEach((v)=>{
        s[v.id] = v.m || 0
      })
      return s
    },
    souhrn_json(){
      return JSON.stringify(this.souhrn)
    }
  }
}
</script>

<template>
<label for="group_lecturer_ids" class="label" v-if="label">{{ label  }} </label>
  <input type="hidden" :name="name" value=""/>
  <select :name="name" multiple="multiple" style="visibility: hidden; height:0;position:absolute;"><option v-for="v in value1" selected :value="v.id">{{v.name}}</option></select>
    <multiselect v-model="value1"
                 :options="collection"
                 track-by="id"
                 label="name"
                 :multiple="true"
                 :close-on-select="true"></multiselect>

  <table class="produkty-a-delka" v-if="value1.length>0">
    <thead>
      <th>ID</th>
      <th>Název</th>
      <th>Délka předplatného (nebo 0 &approx; navždy)</th>
    </thead>
    <tr v-for="v in value1">
      <td>{{v.id}}</td>
      <td>{{v.name}}</td>
      <td><input type="number" v-model="v.m" class="form-control"/></td>
    </tr>
  </table>
  <input type="hidden" v-model="souhrn_json" name="product_months_json"/>

</template>

<style scoped>
.produkty-a-delka{
  border-top: 1px solid silver;
}
.produkty-a-delka td{
  padding: 4px;
  border-bottom: 1px solid silver;
}
</style>